import Swal from "sweetalert2";
import { initIcons } from "./icons";

export function initConfirm() {
  console.log("Confirm system initialized");

  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.dataset.action || form.dataset.actionBulk;
    if (!action) return;
    const isBulk = !!form.dataset.actionBulk;
    const bulkCount = Number(form.querySelector('input[name="selected_count"]')?.value || 0);

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    let result;

    switch (action) {
      case "void":
        result = await confirmVoid({ isBulk, bulkCount });
        if (result.isConfirmed && result.value) {
          const reasonInput = form.querySelector('input[name="void_reason"]');
          if (reasonInput) reasonInput.value = result.value.trim();
          form.submit();
        }
        break;

      case "delete":
        result = await confirmDelete({ isBulk, bulkCount });
        if (result.isConfirmed) form.submit();
        break;

      case "reactivate":
        result = await confirmReactivate({ isBulk, bulkCount });
        if (result.isConfirmed) form.submit();
        break;

      case "validate":
        result = await confirmValidate({ isBulk, bulkCount });
        if (result.isConfirmed) form.submit();
        break;

      default:
        break;
    }
  }, true);
}

async function confirmValidate({ isBulk = false, bulkCount = 0 } = {}) {
  const title = isBulk ? `Validar ${bulkCount} tickets?` : "Validar este ticket?";
  return Swal.fire({
    title,
    text: isBulk
      ? 'Los tickets validos seleccionados se marcaran como "usado".'
      : 'El ticket se marcara como "usado" y no podra usarse nuevamente.',
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, validar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#3ABFF8",
    cancelButtonColor: "#6b7280",
  });
}

async function confirmVoid({ isBulk = false, bulkCount = 0 } = {}) {
  const title = isBulk ? `Anular ${bulkCount} tickets?` : "Anular este ticket?";
  const text = isBulk
    ? "Los tickets seleccionados se marcaran como anulados (no se eliminaran)."
    : "El ticket se marcara como anulado pero NO se eliminara.";
  return Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Si, anular",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#FBBD23",
    cancelButtonColor: "#6b7280",
    input: "textarea",
    inputLabel: "Motivo de anulacion (obligatorio)",
    inputPlaceholder: "Escribe el motivo de la anulacion...",
    inputAttributes: {
      "aria-label": "Motivo de anulacion",
    },
    inputValidator: (value) => {
      if (!value || !value.trim()) return "El motivo de anulacion es obligatorio";
      if (value.trim().length < 3) return "El motivo debe tener al menos 3 caracteres";
      return undefined;
    },
  });
}

async function confirmReactivate({ isBulk = false, bulkCount = 0 } = {}) {
  const title = isBulk ? `Reactivar ${bulkCount} tickets?` : "Reactivar este ticket?";
  return Swal.fire({
    title,
    text: isBulk
      ? 'Los tickets anulados seleccionados volveran al estado "valido".'
      : 'El ticket volvera al estado "valido" y podra ser utilizado nuevamente.',
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Si, reactivar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#36D399",
    cancelButtonColor: "#6b7280",
  });
}

async function confirmDelete({ isBulk = false, bulkCount = 0 } = {}) {
  const firstConfirm = await Swal.fire({
    title: isBulk ? `ELIMINAR ${bulkCount} tickets?` : "ELIMINAR este ticket?",
    html: `
      <div class="text-left space-y-2">
        <p class="font-semibold text-error">Esta accion es IRREVERSIBLE</p>
        <p>${isBulk ? `Los ${bulkCount} tickets seleccionados` : "El ticket"} sera eliminado permanentemente de la base de datos junto con:</p>
        <ul class="list-disc list-inside space-y-1 text-sm">
          <li>Todos sus registros de escaneo</li>
          <li>Dias asignados</li>
          <li>Historial completo</li>
        </ul>
      </div>
    `,
    icon: "error",
    showCancelButton: true,
    confirmButtonText: "Continuar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#DC2626",
    cancelButtonColor: "#6b7280",
    didOpen: (el) => initIcons(el),
  });

  if (!firstConfirm.isConfirmed) return { isConfirmed: false };

  return Swal.fire({
    title: "Confirmacion final",
    html: '<p class="font-semibold mb-3">Escribe <code class="bg-error/20 px-2 py-1 rounded text-error">ELIMINAR</code> para confirmar:</p>',
    icon: "warning",
    input: "text",
    inputPlaceholder: "Escribe ELIMINAR en mayusculas",
    showCancelButton: true,
    confirmButtonText: "SI, ELIMINAR DEFINITIVAMENTE",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#991b1b",
    cancelButtonColor: "#6b7280",
    inputValidator: (value) => {
      if (value !== "ELIMINAR") return 'Debes escribir exactamente "ELIMINAR" en mayusculas';
      return undefined;
    },
  });
}
